import React from "react";
import Menu from "../Menu";
import CommonSendComponent from "../../components/CommonSendComponent";
import { getSendConfig } from "../../Configs/SendConfigs";

const Sendcampaign = () => {
  const config = getSendConfig('campaign');

  return (
    <>
      <Menu />
      <CommonSendComponent config={config} />
    </>
  );
};

export default Sendcampaign;
